import React, { useEffect } from 'react'
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import {
    authProtectedRoutes,
    publicRoutes,
    bothRoutes,
    specialRoutes,
} from "../../routes";
import { prevetHeaderLoad } from '../../helpers/global_helper';
import Home from '../Home';

const RouteHandle = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const restrictedUrl = window.location.pathname;

    return (
        <React.Fragment>

            <div id="ajax-loader">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>

            <Routes>
                {props?.renderSpecialRoutes ?
                    <>
                        {specialRoutes.map((route, id1) => (
                            <React.Fragment key={id1}>
                                {
                                    <Route
                                        path={route.path}
                                        element={route.component}
                                        key={id1}
                                    />
                                }
                            </React.Fragment>
                        ))}
                    </>
                    :
                    <>
                        <Route
                            exact
                            path={"/"}
                            element={<Home />}
                            key={-1}
                        />
                        {bothRoutes.map((route, idx) => (
                            <React.Fragment key={idx}>
                                <Route
                                    index
                                    exact path={route.path}
                                    element={route.component}
                                    key={idx}
                                />
                            </React.Fragment>
                        ))}
                        {publicRoutes.map((route, id1) => (
                            <React.Fragment key={id1}>
                                {
                                    <Route
                                        exact path={route.path}
                                        element={route.component}
                                        key={id1}
                                    />
                                }
                            </React.Fragment>
                        ))}
                        {authProtectedRoutes.map((route, id2) => (
                            <React.Fragment key={id2}>
                                <Route
                                    exact path={route.path}
                                    element={route.component}
                                    key={id2}
                                />
                            </React.Fragment>
                        ))}
                    </>
                }



            </Routes>
        </React.Fragment>
    )
}

export default RouteHandle
